'use strict';

const $ = require('jquery');
const Slide = require('./slide');
const lang = require('../lang');
const Modal = require('../modal');
const template = require('../templates/slot-times-bookings.hbs');
const SublocationSlide = require('./sublocation-slide');
const TrackSlide = require('./track-slide');
const FormSlide = require('./track-slide');
import Keyboard from 'simple-keyboard';

var selectedInputSTB;
var keyboardInstanceSTB;
var slotTimeBookingInstructions = '';

module.exports = class extends Slide {
  constructor(context = {}) {
    let uniqueIdentifierLabel = context.unique_identifier_label;
    let uniqueIdentifierLocal = lang.get(context.unique_identifier_label);
    context = $.extend({}, { title: lang.get('slot_time_booking_title', { uniqueIdentifier: uniqueIdentifierLocal }) }, context);
    context = $.extend({}, { uniqueIdentifierLocal: uniqueIdentifierLocal }, context);
    localStorage.setItem("unique_identification_label", uniqueIdentifierLabel);
    super(template, context);
    this._locationId = context.locationId;
    this._manualAddAllowed = context.manual_add_allowed;
    this._showBookings = context.show_bookings;
    this._showTimeStamp = context.show_timestamp;
    this._uniqueIdentifierLocal = uniqueIdentifierLocal.toLowerCase();
    this._onlyLocation = context.onlyLocation;
    //noinspection JSUnresolvedVariable
    _idletimer = _mainidletimer;
    this.domEvents = {
      'click [data-unique_identification_number]': '_selectSlotTimeBookings',
      'click a[data-nav-next]': '_clickValidation',
      //'mousemove': '_resetIdleTimer',
      'keydown': '_resetIdleTimer',
      'click': '_resetIdleTimer'
    };
    this.on('afterEnter', this._getSlotTimeBookings);
    this.on('afterEnter', this._stopIdleTimer);
    this.on('afterEnter', this._countdown);
    this.on('afterEnter', this._initiateVirtualKeyboardSTB);
    this.on('afterEnter', this._addExtraInfo);
    this.on('beforeLeave', this._removeVirtualKeyboardSTB);
  }

  reset() {
    this.$el.find('form')[0].reset();
  }

  // DOM EVENTS

  _selectSlotTimeBookings(e) {
    e.preventDefault();
    const unique_identification_number = $(e.currentTarget).data('unique_identification_number');
    const regnr = $(e.currentTarget).data('regnr');
    const luprefnr = $(e.currentTarget).data('luprefnr');
    const custom_signature_value = $(e.currentTarget).data('customsignaturevalue');

    localStorage.setItem("unique_identification_number", unique_identification_number);
    localStorage.setItem("regnr", regnr);
    localStorage.setItem("luprefnr", luprefnr);
    if (custom_signature_value !== undefined) {
      localStorage.setItem("custom_signature_value", JSON.stringify(custom_signature_value));
    }

    $("#form_field_unique_identification1").val(unique_identification_number);
    clearInterval(_idleintervalHandler);
    //noinspection JSUnresolvedVariable
    _idletimer = _mainidletimer;
    const locid = $(e.currentTarget).data('loc_id');
    this._skiptracksublocation(locid);
    this._slideshow.navNext();
  }

  _addExtraInfo() {
    if (this._slideshow._track) {
      slotTimeBookingInstructions = this._slideshow._fetchFormInstructionText(this._slideshow._track.instructions, 'track');
    } else if (this._slideshow._sublocation) {
      slotTimeBookingInstructions = this._slideshow._fetchFormInstructionText(this._slideshow._sublocation.location_texts, 'sublocation');
    } else {
      slotTimeBookingInstructions = this._slideshow._fetchFormInstructionText(this._slideshow._location.location_texts, null);
    }
    $("#slotTimeBookingInstructions").text(slotTimeBookingInstructions);
  }

  _getSlotTimeBookings() {
    let sublocation_track = null;
    if (this._slideshow._track) {
      sublocation_track = this._slideshow._track.track_location_id;
    } else if (this._slideshow._sublocation) {
      sublocation_track = this._slideshow._sublocation.sub_location_id;
    }
    $(".choice-list").addClass('choice-list--two-columns');
    $("#unique_identification_number_block").html('');
    if (this._showBookings === 1) {
      $.ajax({
        method: 'POST',
        url: 'slideshow/getslottimebookings',
        data: { 'locationId': this._locationId,'sublocation_track':sublocation_track, 'show_timestamp': this._showTimeStamp,'onlyLocation': this._onlyLocation },
        success: function (res) {
          var response = JSON.parse(res);
          if (response.status == 'false') {
            $("#lp_message").show();
            setInterval(function () {
              $("#lp_message").hide();
            }, 10000);
          } else {
            var returnabledata = "";
            for (var x = 0; x < response.length; x++) {
              var localTime = '';

              // Check if dates is an empty string
              if (response[x]['dates']) {
                // Extract date and time parts from the response
                var datePart = response[x]['dates'].split(' ')[0];
                var timePart = response[x]['dates'].split(' ')[1];

                // Combine date and time to create a full UTC DateTime
                var utcDateTime = new Date(datePart + "T" + timePart + "Z");

                // Get tomorrow's date
                var tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                var tomorrowDate = tomorrow.toISOString().split('T')[0];

                // Convert to local time
                localTime = utcDateTime.toLocaleTimeString('sv').split(':').slice(0, 2).join(':'); // Extract HH:MM

                // Add "+1d" if the booking is for tomorrow
                if (datePart === tomorrowDate) {
                  localTime += " +1d";
                }
              }

              if (response[x]['unique_identification_number'] === '') {
                continue;
              }

              returnabledata += '<li>';
              returnabledata += '<a href="#/" ';

              if (response[x]['custom_signature_value'] != '') {
                var customdataval = response[x]['custom_signature_value'];
                var encodedCustomDataVal = encodeURIComponent(JSON.stringify(customdataval));
                returnabledata += `data-customsignaturevalue="${encodedCustomDataVal}" `;
              }

              returnabledata += 'data-loc_id="' + response[x]['sublocation_track'] + '" ';
              returnabledata += 'data-regnr="' + response[x]['regnr'] + '" ';
              returnabledata += 'data-luprefnr="' + response[x]['refnr'] + '" ';
              returnabledata += 'data-unique_identification_number="' + response[x]['unique_identification_number'] + '">';
              returnabledata += response[x]['unique_identification_number'];
              returnabledata += ' <small style="float: right;">' + localTime + '</small>';
              returnabledata += '</a>';
              returnabledata += '</li>';
            }


            $("#unique_identification_number_block").html(returnabledata);
          }
        },
      });
    }
  }


  _validation() {
    const emptyFields = [];
    this.$el.find('input[required]').each(function () {
      const $this = $(this);
      if ($this.val().length === 0)
        emptyFields.push($this);
    });

    if (emptyFields.length !== 0) {
      new Modal({
        titleText: lang.get('form_modal_title'),
        bodyText: lang.get('form_modal_body'),
        submitBtnText: lang.get('form_modal_button'),
        onHidden: () => emptyFields[0].focus()
      });
      return false;
    }
    return true;
  }

  _clickValidation(e) {
    clearInterval(_idleintervalHandler);
    //noinspection JSUnresolvedVariable
    _idletimer = _mainidletimer;

    if (!this._validation()) {
      return false;
    }

    var slideshowstatus = this._getSlotTimeBookingStatus();
    slideshowstatus = JSON.parse(slideshowstatus);
    if (slideshowstatus['status'] === 'no') {
      new Modal({
        titleText: lang.get('identification_modal_title'),
        bodyText: slotTimeBookingInstructions || lang.get('identification_modal_body'),
        submitBtnText: lang.get('form_modal_button')
      });
      return false;
    } else if (slideshowstatus['status'] === 'checkedin') {

      var message = lang.get('checked_in_modal_body', { uniqueIdentifierLocal: this._uniqueIdentifierLocal});
      if (slideshowstatus['bay_info']) {
        message += ' ' + lang.get('checked_in_modal_bay', { bay_info: slideshowstatus['bay_info'] });
      }
      new Modal({
        titleText: lang.get('identification_modal_title'),
        bodyText: message,
        submitBtnText: lang.get('form_modal_button')
      });
      return false;
    } else {
      this._skiptracksublocation(slideshowstatus['sublocortrackid']);
    }

    localStorage.setItem('luprefnr', slideshowstatus['luprefnr']);
    if (slideshowstatus['regnr'] !== undefined) {
      localStorage.setItem('regnr', slideshowstatus['regnr']);
    }
    if (slideshowstatus['unique_identification_number']) {
      localStorage.setItem("unique_identification_number", slideshowstatus['unique_identification_number']);
    } else {
      localStorage.setItem("unique_identification_number", $("#form_field_unique_identification1").val());
    }

    // Store CustomSignatureValues in localStorage with URL encoding
    if (slideshowstatus['CustomSignatureValues'] !== undefined) {
      const encodedCustomSignatureValues = encodeURIComponent(JSON.stringify(slideshowstatus['CustomSignatureValues']));
      localStorage.setItem("custom_signature_value", encodedCustomSignatureValues);
    }

    // Show TrackSlide if location_before_booking is 0
    if (this._slideshow._location.unique_identifier_setting && this._slideshow._location.unique_identifier_setting.location_before_booking === 0 && !slideshowstatus['sublocortrackid']) {
      const trackSlideIndex = this._slideshow.findIndex(TrackSlide);
      if (trackSlideIndex === -1 && this._slideshow._location.tracks.length !== 0 && this._slideshow._location.tracks.length !== 1) {
        const trackSlide = new TrackSlide({ tracks: this._slideshow._location.tracks });
        const index = this._slideshow.currentIndex + 1;
        this._slideshow.add(trackSlide, index);
      }
      else if (this._slideshow._location.tracks.length === 1) {
        this._skiptracksublocation(this._slideshow._location.tracks[0].track_location_id);
      }
    }
  }

  _resetIdleTimer() {
    $('.idle-timer-container').hide();
    //noinspection JSUnresolvedVariable
    _idletimer = _mainidletimer;
  }

  _countdown() {
    //noinspection JSUnresolvedVariable
    _idletimer = _mainidletimer;
    $('.idle-timer-container').hide();
    const $domTimer = this.$el.find('#idle-timer');
    //noinspection JSUnresolvedVariable
    _idleintervalHandler = setInterval(() => {
      //noinspection JSUnresolvedVariable
      _idletimer -= 1;
      if (_idletimer <= 30) {
        $('.idle-timer-container').show();
        $domTimer.html(_idletimer);
      }
      if (_idletimer === 0) {
        this._slideshow._clearForm();
        $('#modal').modal('hide');
        clearInterval(_idleintervalHandler);
        //noinspection JSUnresolvedVariable
        _idletimer = _mainidletimer;
        $('.idle-timer-container').hide();
        window.location.hash = '/';
      }
    }, 1000);
  }

  _stopIdleTimer() {
    if (_idleintervalHandler !== undefined) {
      clearInterval(_idleintervalHandler);
    }
  }

  _getSlotTimeBookingStatus() {

    var identification_number = $('#form_field_unique_identification1').val();
    var ajaxResponse = '';
    var trackOrSublocationId = this._slideshow?._track?.track_location_id || this._slideshow?._sublocation?.location_id;

    $.ajax({
      method: 'POST',
      async: false,
      url: 'slideshow/getslottimebookingstatus',
      data: {
        'locationId': this._locationId,
        'trackOrSublocationId': trackOrSublocationId,
        'identification_number': identification_number
      },
      success: function (result) {
        ajaxResponse = result;

      },
    });

    return ajaxResponse;

  }


  _skiptracksublocation(sublocortrackid) {
    if (this._slideshow._location.module_slot_time_booking === 1 &&
      this._slideshow._location.unique_identifier_setting.location_before_booking) {
      return;
    }
    var sublocSlide = this._slideshow.findIndex(SublocationSlide);
    var trackSlide = this._slideshow.findIndex(TrackSlide);

    if (parseInt(sublocortrackid) > 0) {
      const sublocationdata = this._slideshow._location.sub_locations.find((sublocation) => sublocation.id == sublocortrackid);
      var trackslidedata = '';
      var trackparentslidedata = '';
      if (sublocationdata != undefined) {
        this._slideshow.setSublocation(sublocationdata);

      } else if (sublocationdata == undefined) {
        if (this._slideshow._location.sub_locations && this._slideshow._location.sub_locations.length != 0) {
          $.each(this._slideshow._location.sub_locations, function (k, v) {
            var subtrackmatch = v.tracks.find((track) => track.track_data.id == sublocortrackid);
            if (subtrackmatch != undefined) {
              trackparentslidedata = v;
              trackslidedata = subtrackmatch;
            }
          })
        }

        if (this._slideshow._location.tracks && this._slideshow._location.tracks.length != 0) {
          const loctrackmatch = this._slideshow._location.tracks.find((loctrackmatch) => loctrackmatch.track_data.id == sublocortrackid);

          if (loctrackmatch != undefined) {
            trackslidedata = loctrackmatch;
          }
        }
      }
      else {
        var trackdata = this._slideshow._location.tracks.find((tracks) => tracks.id == sublocortrackid);
        if (trackdata != undefined) {
          this._slideshow.setTrack(trackdata);
        }
      }

      if (trackparentslidedata != '') {
        this._slideshow._sublocation = trackparentslidedata;
      }

      if (trackslidedata != '') {
        this._slideshow.setTrack(trackslidedata);
      }

      if (sublocSlide !== -1 && this._slideshow._location.module_slot_time_booking === 1) {
        for (let i = this._slideshow.slides.length - 1; i >= 0; i--) {
          const slide = this._slideshow.slides[i];
          if (slide instanceof SublocationSlide)
            this._slideshow.remove(i);
        }
      }


      if (trackSlide !== -1) {
        for (let i = this._slideshow.slides.length - 1; i >= 0; i--) {
          const slide = this._slideshow.slides[i];
          if (slide instanceof TrackSlide)
            this._slideshow.remove(i);
        }
      }


    } else {
      if (sublocSlide == -1) {
        if (this._slideshow._location.sub_locations.length !== 0) {
          const subLocationSlide = new SublocationSlide({ sub_locations: this._slideshow._location.sub_locations });
          const index = this._slideshow.currentIndex + 1;
          this._slideshow.add(subLocationSlide, index);
        }
      }
      if (trackSlide == -1) {
        if (this._slideshow._location.tracks.length !== 0) {
          const trackSlide = new TrackSlide({ tracks: this._slideshow._location.tracks });
          const index = this._slideshow.currentIndex + 1;
          this._slideshow.add(trackSlide, index);
        }
      }
    }

  }

  _initiateVirtualKeyboardSTB() {
    $("#virtualKeyboardForm").removeClass("simple-keyboard");
    $("#virtualKeyboardOTP").removeClass("simple-keyboard");
    let firstInput = document.querySelector('#form_field_unique_identification1');
    if (firstInput) {
      firstInput.focus();
      selectedInputSTB = `#${firstInput.id}`; // Assigning the variable defined at a higher scope
    }
    $("#virtualKeyboardSlotTimeBooking").addClass("simple-keyboard");
    function onDocumentClickSTB(event) {
      // Get the active element
      const activeElement = document.activeElement;
      if (event.target.classList.contains('form-control')) {
        // If the clicked target is a different form control, focus it
        if (activeElement !== event.target) {
          event.target.focus();  // Manually focus the target
        }
        return; // Exit from the function early as there's no need to process other conditions
      }

      // Check if the clicked target is not a form control and not part of the simple-keyboard
      if (!event.target.classList.contains('form-control') && !$(event.target).closest(".simple-keyboard").length) {
        // If the active element is a form control, then blur it to hide keyboard
        if (activeElement && activeElement.classList.contains('form-control')) {
          activeElement.blur();
        }
      }
    }


    // Attach the click event handler to the document

    if (localStorage.getItem('virtualKeyboard') === 'true') {
      $(document).on('click touchstart', onDocumentClickSTB);
      $('body').addClass('virtual-keyboard-active');


      const defaultTheme = "hg-theme-default";


      $(document).on('focus', '.form-control', function () {
        $(".simple-keyboard").show();
      });

      $(document).on('touchstart', '.form-control', function () {
        $(".simple-keyboard").show();
      });

      $(document).on('blur', '.form-control', function () {
        $(".simple-keyboard").hide();
      });

      if (keyboardInstanceSTB) {
        keyboardInstanceSTB.destroy(); // Replace with the actual method to destroy the keyboard if it exists
      }


      keyboardInstanceSTB = new Keyboard({
        onChange: input => onChangeSTB(input),
        theme: defaultTheme,
        layout: {
          'default': [
            '1 2 3 4 5 6 7 8 9 0 {bksp}',
            'Q W E R T Y U I O P Å',
            'A S D F G H J K L Ä Ö',
            'Z X C V B N M . - @',
            '{space}'
          ],
        },
        display: {
          '{bksp}': '⌫',
          '{space}': ' '
        }
      });

      document.querySelectorAll(".form-control").forEach(input => {
        input.addEventListener("focus", onInputFocusSTB);
        input.addEventListener("touchstart", onInputFocusSTB); // Add this line
        input.addEventListener("input", onInputChangeSTB);
      });

      function onInputFocusSTB(event) {
        selectedInputSTB = `#${event.target.id}`;
        const inputValue = document.querySelector(selectedInputSTB).value;
        keyboardInstanceSTB.setInput(inputValue, event.target.id);
        keyboardInstanceSTB.setOptions({
          inputName: event.target.id
        });
      }

      function onInputChangeSTB(event) {
        keyboardInstanceSTB.setInput(event.target.value, event.target.id);
      }

      function onChangeSTB(input) {
        const inputElem = document.querySelector(selectedInputSTB || ".input");
        inputElem.value = input;
        inputElem.dispatchEvent(new Event('input'));
      }

    }
  }

  _removeVirtualKeyboardSTB() {
    if (keyboardInstanceSTB !== undefined) keyboardInstanceSTB.destroy();
    $("#virtualKeyboardSlotTimeBooking").removeClass("simple-keyboard");
  }

};
